import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import CallToActions from '../CallToActions/CallToActions.jsx'

import './Header.scss'

export default class Header extends PureComponent {
  static defaultProps = {
    bgImg: null,
    brief: null,
    ctas: null,
    imageAlt: null,
    imageSrc: null,
  }

  static propTypes = {
    bgImg: PropTypes.string,
    brief: PropTypes.element,
    ctas: PropTypes.element,
    imageAlt: PropTypes.string,
    imageSrc: PropTypes.string,
    title: PropTypes.string.isRequired,
  }

  render() {
    const {brief, ctas, imageSrc, ...props} = this.props

    const header = <header className="container py-4 pt-md-5 mb-4">
      <div className="row align-items-center">
        <div className={`col-lg-${imageSrc ? '7' : '12'} text-center text-lg-left`}>
          <h1 className={`${imageSrc ? '' : 'text-center '}mb-4`}>{props.title}</h1>
          {brief ? <div className={`${imageSrc ? '' : 'text-center '}mb-4`}>{brief}</div> : ''}
          <CallToActions className="justify-content-lg-start">{ctas}</CallToActions>
        </div>
        {imageSrc ?
          <img className="d-none d-lg-block col-lg-5" src={imageSrc} alt={props.imageAlt}/> : ''
        }
      </div>
    </header>

    if (props.bgImg !== null) {
      return <div
        className="header-background"
        style={{
          background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${props.bgImg}) no-repeat right center/cover`
        }}
      >
        {header}
      </div>
    }

    return header
  }
}
